import { render } from "./profileCard.vue?vue&type=template&id=4242a821"
import script from "./profileCard.vue?vue&type=script&lang=js"
export * from "./profileCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__